import { gql } from "@apollo/client";

export const GET_MEASUREMENTS_BY_IDS_QUERY = gql`
  query MeasurementsByIds($ids: [String]) {
    measurementsByIds(ids: $ids) {
      _id
      unique_identifier
      value
    }
  }
`;
